import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Badge from "@mui/material/Badge";
import NotificationsIcon from "@mui/icons-material/Notifications";
import {
  getNotificationAll,
  markNotification,
} from "../../services/notificationSevices";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { toast } from "react-toastify";

export default function Notification() {
  const [notifications, setNotifications] = useState(0);
  const [agreementsToExpire, setAgreementsToExpire] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getNotifications = async () => {
    try {
      const res = await getNotificationAll();
      
      setNotifications(res.data.quantity);
      setAgreementsToExpire(res.data.info);
    } catch (err) {
      if (!err?.response) {
        toast.error("No responde el servidor");
        
      } else {
        toast.error(err.response.data.error);
      }
    }
  };

  const handleShowAgreement = async (id, notification_id) => {
    navigate(`/agreement/show/${id}`, {
      replace: true,
      state: {
        displayHead: true,
        headerTitle: "Información del convenio",
      },
    });

    try {
      const res = await markNotification(notification_id);
    } catch (err) {
      if (!err?.response) {
        toast.error("No responde el servidor");
        
      } else {
        toast.error(err.response.data.error);
      }
    }
    getNotifications();
  };

  useEffect(() => {
    getNotifications();
  }, []);
  return (
    <div>
      <Badge
        badgeContent={notifications}
        color="secondary"
        onClick={handleClick}
      >
        <NotificationsIcon />
      </Badge>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {agreementsToExpire?.length > 0 ? (
          agreementsToExpire.map((item, index) => (
            <MenuItem onClick={handleClose} key={index}>
              <span
                onClick={() => handleShowAgreement(item.agreement_id, item.id)}
              >
                {item.message} - <strong>{item.agreement_number}</strong>
              </span>
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>
            <em>No hay notificaciones</em>
          </MenuItem>
        )}
      </Menu>
    </div>
  );
}
